export default "__VITE_ASSET__CiXkGL$q__"